/*

=========================================================
* Now UI Kit React - v1.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/now-ui-kit-react
* Copyright 2019 Creative Tim (http://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/now-ui-kit-react/blob/master/LICENSE.md)

* Designed by www.invisionapp.com Coded by www.creative-tim.com

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter, Route, Switch, Redirect, useLocation } from "react-router-dom";

// styles for this kit
import "assets/css/bootstrap.min.css";
import "assets/scss/now-ui-kit.scss";
import "assets/scss/main.scss";
import "assets/demo/demo.css";
import "assets/demo/nucleo-icons-page-styles.css";
// pages for this kit
import Index from "views/Index.js";
import AboutPage from "views/about/AboutPage.js";
import DogsPage from "views/dogs/DogsPage.js";
import LittersPage from "views/litters/LittersPage.js";
import ContactPage from "views/contact/ContactPage.js";

function ScrollToTop() {
  const { pathname } = useLocation();

  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

ReactDOM.render(
  <BrowserRouter>
    <ScrollToTop />
    <Switch>
      <Route exact path="/" render={props => <Index {...props} />} />
      <Redirect exact from="/index" to="/" />
      <Route
        path="/about"
        render={props => <AboutPage {...props} />}
      />
      <Route
          path="/dogs"
          render={props => <DogsPage {...props} />}
      />
      <Route
          path="/litters"
          render={props => <LittersPage {...props} />}
      />
      <Route
          path="/contact"
          render={props => <ContactPage {...props} />}
      />
      <Redirect to="/" />
    </Switch>
  </BrowserRouter>,
  document.getElementById("root")
);
